// post-modal.js
import Modal from 'bootstrap/js/dist/modal';

(function ($) {
  // Ustal bazę REST (kolejność priorytetu: wpPostModal.restUrl -> wpApiSettings.root -> /wp-json/wp/v2/)
  const REST_BASE =
    (window.wpPostModal && window.wpPostModal.restUrl) ||
    (window.wpApiSettings && window.wpApiSettings.root + 'wp/v2/') ||
    '/wp-json/wp/v2/';

  function ensureModal() {
    let $modal = $('.app-modal');
    if ($modal.length === 0) {
      $('body').append(`
        <div class="modal fade app-modal" tabindex="-1" aria-hidden="true" data-bs-theme="dark">
          <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title"></h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Zamknij"></button>
              </div>
              <div class="modal-body"></div>
            </div>
          </div>
        </div>
      `);
      $modal = $('.app-modal');
    }
    return $modal;
  }

  function showLoading($modal) {
    $modal.find('.modal-title').text('Wczytywanie…');
    $modal.find('.modal-body').html(`
      <div class="d-flex align-items-center">
        <div class="spinner-border me-2" role="status" aria-hidden="true"></div>
        <span>Proszę czekać…</span>
      </div>
    `);
  }

  function openPostInModal(postId) {
    const $modal = ensureModal();
    showLoading($modal);

    // const url = `${REST_BASE}pages/${postId}?_embed=1`;
    const url = `/?rest_route=/wp/v2/pages/${postId}`;

    $.ajax({
      url,
      method: 'GET',
      dataType: 'json',
      headers: (window.wpPostModal && window.wpPostModal.nonce)
        ? { 'X-WP-Nonce': window.wpPostModal.nonce }
        : undefined
    })
      .done(function (data) {
        // Tytuł bez HTML do <h5>
        const titleText = $('<div>').html(data.title?.rendered || '').text();
        const bodyHtml  = data.content?.rendered || '<p>(Brak treści)</p>';

        $modal.find('.modal-title').text(titleText);
        $modal.find('.modal-body').html(bodyHtml);

        // Opcjonalnie: obrazek wyróżniony
        const featured = data._embedded?.['wp:featuredmedia']?.[0]?.source_url;
        if (featured) {
          $modal.find('.modal-body').prepend(
            `<img src="${featured}" class="img-fluid mb-3" alt="">`
          );
        }
      })
      .fail(function (xhr) {
        $modal.find('.modal-title').text('Błąd');
        $modal.find('.modal-body').html(`
          <div class="alert alert-danger mb-0">
            Nie udało się pobrać artykułu (status ${xhr.status}).
          </div>
        `);
      })
      .always(function () {
        const modal = new Modal($modal[0]);
        modal.show();
      });
  }

  // Delegacja: dowolny przycisk/link z data-post-id
  $(document).on('click', '.js-open-post-modal', function (e) {
    e.preventDefault();
    const id = $(this).data('post-id');
    if (!id) return;
    openPostInModal(id);
  });
})(jQuery);
